import { useCallback } from "react";

import { ObservableQuery } from "@apollo/client";
import { FormattedMessage, useIntl } from "react-intl";
import { useShallow } from "zustand/react/shallow";

import { CtaModal } from "ui/CtaModal";
import { WarningThreeIcon } from "ui/Icons/Icons";
import { BodyM } from "ui/Typography/Typography";

import { useInboundStore } from "../stores/inboundStore/useInboundStore";
import { useUnClaimInboundList } from "../stores/useInboundDropService";

export function UnclaimListModal({
  refetchInboundingLists,
}: {
  refetchInboundingLists: ObservableQuery["refetch"];
}) {
  const intl = useIntl();
  const { inboundUIState } = useInboundStore(
    useShallow((state) => ({
      inboundUIState: state.inboundUIState,
    })),
  );
  const { unClaimInboundList, isUnClaimingList } = useUnClaimInboundList(refetchInboundingLists);
  const handleOnclick = useCallback(async () => {
    if (!isUnClaimingList && inboundUIState.isUnclaimListModalVisible) {
      unClaimInboundList({
        listId: inboundUIState.isUnclaimListModalVisible,
        deliverySSCC: null,
        deliveryType: null,
        creatorId: null,
        orderId: null,
      });
    }
  }, [inboundUIState.isUnclaimListModalVisible, isUnClaimingList, unClaimInboundList]);
  return (
    <CtaModal
      isOpen
      onClose={() => {}}
      hideCloseButton
      onClickCta={handleOnclick}
      headerIcon={<WarningThreeIcon boxSize="80px" />}
      title={intl.formatMessage({
        id: "flows.inbound.components.unclaim-list-modal.title",
      })}
      ctaLabel={intl.formatMessage({
        id: "flows.inbound.components.unclaim-list-modal.cta",
      })}
      body={
        <BodyM textAlign="center">
          <FormattedMessage id="flows.inbound.components.unclaim-list-modal.body" />
        </BodyM>
      }
    />
  );
}
